/* eslint-disable global-require */

const inProduction = false;

const production = {
  API_URL: 'https://appsupply.portalgr.com.br/apisupply/api',
  API_AUTHORIZATION: `${sessionStorage.getItem('@GR:token')}`,
  IMAGES_URL: 'https://appsupply.portalgr.com.br/apisupply',
  TOKEN_USER: 'gr',
  TOKEN_PASSWORD: '@gr2022',
};

const development = {
  API_URL: 'https://homologacao.egestao.net/Supply/api',
  API_AUTHORIZATION: `${sessionStorage.getItem('@GR:token')}`,
  IMAGES_URL: 'https://homologacao.egestao.net/Supply',
  TOKEN_USER: 'gr',
  TOKEN_PASSWORD: '@gr@2022',
};

const keyEncrypt = 'Every straight line is an arc of an infinite circle';

export const variables = inProduction ? production : development;

export const encryptor = require('simple-encryptor')(keyEncrypt);
